import {Moment} from 'moment';
import {IDischargeModel, IImomoResponse} from './api.types';

export interface IDischargeModelRequest {
  modelName: string;
  paramA: number;
  paramB: number;
  paramC: number;
  paramDeltaLevel: number;
  validFrom: Moment;
  siteId: number;
}

export interface IDischargeModelApi {
  createDischargeModel(dischargeModelRequest: IDischargeModelRequest): ng.IPromise<IDischargeModel>;
  getDischargeModels(stationId: number,
                     year: number): ng.IPromise<IDischargeModel[]>;
  deleteDischargeModel(dischargeModelId: number): ng.IPromise<void>;
}

export default class DischargeModelApi implements IDischargeModelApi {
  static $inject = ['backendUrl', '$http'];

  private endpoint: string;

  constructor(backendUrl: string, private $http: ng.IHttpService) {
    this.endpoint = `${backendUrl}/discharge_models`
  }

  createDischargeModel(dischargeModelRequest: IDischargeModelRequest) {
    return this.$http<IImomoResponse<IDischargeModel>>({
      url: this.endpoint,
      method: 'POST',
      data: dischargeModelRequest
    }).then(httpData => {
      return httpData.data.resources[0];
    });
  }

  getDischargeModels(stationId: number,
                     year: number): ng.IPromise<IDischargeModel[]> {
    return this.$http<IImomoResponse<IDischargeModel>>({
      url: this.endpoint,
      method: 'GET',
      params: {
        year: year,
        hydroYear: false,
        siteId: stationId
      }
    }).then(httpData => httpData.data.resources);
  }

  deleteDischargeModel(dischargeModelId: number): ng.IPromise<void> {
    return this.$http<IImomoResponse<IDischargeModel>>({
      url: `${this.endpoint}/${dischargeModelId}`,
      method: 'DELETE'
    }).then(httpData => {
    });
  }
}



/** WEBPACK FOOTER **
 ** ./app/api/discharge-model-api.service.ts
 **/